import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/uiStore'
import { navItems } from './navItems'

export function MobileMenu() {
  const { mobileMenuOpen, toggleMobileMenu, inboxBadge } = useUIStore()
  const location = useLocation()

  if (!mobileMenuOpen) return null

  return (
    <>
      {/* Backdrop */}
      {/* C4: replaced deprecated bg-obsidian-950/50 with pure black at matching opacity */}
      <div
        className="fixed inset-0 z-30 backdrop-blur-sm md:hidden"
        style={{ background: 'rgba(0,0,0,0.50)' }}
        onClick={toggleMobileMenu}
      />
      {/* Drawer */}
      {/* C4: replaced bg-obsidian-900/95 with MIDNIGHT bg token */}
      {/* C5: replaced top-16 (64px hardcode) with safe-area-relative calc matching Topbar's actual height */}
      <div
        className="fixed left-0 bottom-0 z-40 w-64 backdrop-blur-xl hairline-r md:hidden overflow-y-auto"
        // Reads --safe-top from index.css; the canonical way to consume the
        // top safe-area inset without hand-rolling env() (CLAUDE.md §8).
        style={{
          top: 'calc(var(--safe-top) + 3.5rem)',
          background: 'var(--midnight-bg, #000000)',
        }}
      >
        <nav className="py-3 space-y-0.5 px-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path ||
              (item.path !== '/dashboard' && location.pathname.startsWith(item.path + '/'))
            const Icon = item.icon
            const badge = item.path === '/inbox' ? inboxBadge : (item.badge ?? 0)
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={toggleMobileMenu}
                className={cn(
                  'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 min-h-[50px]',
                  isActive
                    ? 'nav-pill-active text-ink-50'
                    : 'text-ink-400 hover:text-ink-100 hover:bg-white/[0.03]'
                )}
              >
                <Icon className="w-4 h-4 shrink-0" />
                <span>{item.label}</span>
                {badge > 0 && (
                  <span className="ml-auto inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-semibold tabular-nums bg-peach-500/20 text-peach-200 border border-peach-500/30">
                    {badge}
                  </span>
                )}
              </NavLink>
            )
          })}
        </nav>
      </div>
    </>
  )
}
